export default __webpack_public_path__ + "static/media/PrafullAnubhai.b2ff75b1.jpg";